import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { WorkforceDatesSummary, WorkforceReport } from 'src/app/models/workforce-report.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReportService {
	private baseUrl = `${environment.baseUrl}/report`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	requestWorkforceReport(assetId: number, request: WorkforceReport): Observable<void>{
		return this.httpClient.post<void>(`${this.baseUrl}/workforce-report/${assetId}`, request);
	}

	@ApiMethod()
	requestWorkforceReportBySite(siteId: number, request: any): Observable<void>{
		return this.httpClient.post<void>(`${this.baseUrl}/workforce-report-bySite/${siteId}`, request);
	}

	@ApiMethod()
	getCompletedOnDemandDates(assetId: number): Observable<string[]> {
		return this.httpClient.get<string[]>(`${this.baseUrl}/workforce-report/${assetId}/dates`);
	}

	@ApiMethod()
	getOnDemandFormSummary(siteId: number, pageSize: number = 5, pageCount: number = 1): Observable<WorkforceDatesSummary> {
		return this.httpClient.get<WorkforceDatesSummary>(`${this.baseUrl}/workforce-report-bysite/${siteId}/dates?pageSize=${pageSize}&pageNumber=${pageCount}`);
	}
}
